import { Ajax, Envs } from '@common';
import { React, Styled } from '@common/3rd';
import { PageComponents } from '@my-types';
import { Phone } from '@styles';
import Widget from '../widget';
import PageBody from './page-body';
import PageFooter from './page-footer';
import PageHeader from './page-header';

/**
 * Page component which contains header, body and footer
 */
abstract class Page<P, S, C extends PageComponents> extends Widget<P, S, C> {
	// constructor(props: any, context?: any) {
	// 	super(props, context);
	// }
	protected initComponents(): C {
		return {
			Box: Styled.div.attrs({
				'data-widget': 'page'
			})`
				min-height: 100vh;
				overflow: hidden;
				${Phone.only`
					min-height: ${window.innerHeight}px
				`}

				display: flex;
				flex-direction: column;
			`
		} as C;
	}
	componentDidMount() {
		super.componentDidMount();
		this.initTheme();
	}
	protected renderPageHeader(): JSX.Element | null | void {
		return <PageHeader />;
	}
	protected renderPageBody(): JSX.Element | null | void {
		return <PageBody />;
	}
	protected renderPageFooter(): JSX.Element | null | void {
		return <PageFooter />;
	}
	render() {
		const C = this.C;
		return (
			<C.Box>
				{this.renderPageHeader()}
				{this.renderPageBody()}
				{this.renderPageFooter()}
			</C.Box>
		);
	}
	/**
	 * 根据页面切换, 显示不同的标题, 需要指定的标题, 使用子类重写
	 *
	 * @return {string} 默认返回null
	 */
	protected abstract getHtmlTitle(): string | null;
	/**
	 * 初始化主题, 始终返回resolved promise
	 *
	 * @param retrieve 是否需要发请求获取用户信息, 默认需要
	 */
	protected initTheme(retrieve: boolean = true): Promise<void> {
		const theme = Envs.getCurrentTheme();
		if (theme) {
			Envs.application()!.changeTheme(theme);
		} else if (retrieve && Ajax.isAuthorized()) {
			// 重新请求一次账户信息, 不需要处理返回
			Ajax.retrieveAccount(null, null, () => {}, () => {});
		}
		return Promise.resolve();
	}
}

export default Page;
